module.exports = __webpack_public_path__ + "static/assets/d24add2b62c8e0e2cf22ab9799c00a94.svg";